import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as AOS from 'aos';
import { CommentService } from 'app/services/comment.serivce';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {

  commentForm!: FormGroup;
  commentList: Comment[] = [];

  constructor(
    private fb: FormBuilder,
    private commentService: CommentService,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    // Initialize AOS (Animate On Scroll) library
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });


    this.initForm();
    this.getComments();
  }
  initForm() {
    this.commentForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      comment: ['', Validators.required],

    });
  }

  /**
   * Add Comment
   */
  submitComment() {
    if (this.commentForm.invalid) {
      this.toaster.error('Please fill all required fields', '');
      return;
    }

    this.commentService.addComment(this.commentForm.value)
      .subscribe(
        (res: any) => {
          this.toaster.success('Comment added successfully...', '');
          this.getComments();
          this.commentForm.reset();
        },
        (error) => {
          this.toaster.error(error?.message || 'Something went wrong', '');
        }
      );
  }

  /**
   * Get Comments
   */
  getComments() {
    this.commentService.getComments()
      .subscribe({
        next: (res: any) => {
          this.commentList = res;
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

}
